/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Erp_FilesInputs */

const en_nav_erp_files = /** @type {(inputs: Nav_Erp_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files to the ERP`)
};

/**
* | output |
* | --- |
* | "Files to the ERP" |
*
* @param {Nav_Erp_FilesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_erp_files = /** @type {((inputs?: Nav_Erp_FilesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Erp_FilesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_erp_files(inputs)
});